import { render, staticRenderFns } from "./SettingsCatalog.vue?vue&type=template&id=3737d679&"
import script from "./SettingsCatalog.vue?vue&type=script&lang=ts&"
export * from "./SettingsCatalog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports